import React, { Component } from "react";
import OptimisedImage from "../components/optimisedImage";
import { Link, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import WorkforceLogo from "../assets/images/WF-colored.svg";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      country: "us",
    };
  }

  componentDidMount() {
    this.setCountry();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setCountry();
      return true;
    }
  }

  setCountry = () => {
    const currentLocation = window.location.pathname;
    const firstPath = currentLocation.split("/");

    if (firstPath[1] === "uk") {
      this.setState({
        country: "uk",
      });
    } else {
      this.setState({
        country: "us",
      });
    }
  };

  render() {
    return (
      <footer className="container sm:mx-auto py-12">
        <section className="flex items-start justify-between lg:justify-center flex-wrap lg:flex-no-wrap mb-8 px-4 ">
          <div className="footer__brand w-full lg:w-auto lg:mr-16">
            <OptimisedImage
              src={WorkforceLogo}
              alt="Workforce.com"
              className="mb-4"
            />
            <p className="leading-snug text-sm text-gray-500">
              Improve your labor operations with the world leader in workforce
              management
            </p>
            <div className="flex py-4">
              <a
                href="https://www.facebook.com/Workforcedotcom/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 mr-6"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a
                href="https://twitter.com/workforcedotcom"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 mr-6"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href="http://linkedin.com/company/workforcemanagement"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 mr-6"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
              <a
                href="https://www.youtube.com/channel/UCpDoOWR212YK3D_7Iyve3pQ"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>
          </div>

          <div className="w-1/2 mb-6 sm:mb-0 lg:mr-12  sm:w-auto">
            <p className="text-sm text-blue-dark leading-tight my-3 font-secondary">
              Product
            </p>
            <ul>
              <li>
                <Link
                  to={
                    this.state.country === "us"
                      ? "/software/scheduling-software"
                      : "/uk/software/rota"
                  }
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Scheduling Software
                </Link>
              </li>
              <li>
                <Link
                  to={
                    this.state.country === "us"
                      ? "/software/time-and-attendance"
                      : "/uk/software/time-and-attendance"
                  }
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Time & Attendance
                </Link>
              </li>
              <li>
                <Link
                  to={
                    this.state.country === "us"
                      ? "/software/employee-app"
                      : "/uk/software/employee-app"
                  }
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Employee App
                </Link>
              </li>
              <li>
                <Link
                  to={
                    this.state.country === "us"
                      ? "/software/workforce-analytics"
                      : "/uk/software/workforce-analytics"
                  }
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Workforce Analytics
                </Link>
              </li>
              {this.state.country === "us" ? (
                <li>
                  <Link
                    to="/software/wage-and-hour-compliance"
                    className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                  >
                    {this.state.country === "us" ? "Wage and Hour" : "Labour"}{" "}
                    Compliance
                  </Link>
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>

          <div className="w-1/2 mb-6 sm:mb-0 lg:mr-12 sm:w-auto">
            <p className="text-sm text-blue-dark leading-tight my-3 font-secondary">
              Content
            </p>
            <ul>
              <li>
                <a
                  href={this.state.country === "us" ? "/news" : "/uk/news"}
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  News
                </a>
              </li>
              <li>
                <Link
                  to={
                    this.state.country === "us" ? "/research" : "/uk/research"
                  }
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Research
                </Link>
              </li>
              <li>
                <a
                  href="https://resources.workforce.com/whitepapers"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Whitepapers
                </a>
              </li>
              <li>
                <a
                  href="https://magazine.workforce.com/"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Magazine
                </a>
              </li>
              <li>
                <Link
                  to={this.state.country === "us" ? "/videos" : "/uk/videos"}
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Videos
                </Link>
              </li>
              <li>
                <a
                  href={
                    this.state.country === "us"
                      ? "/wf-events/webinars"
                      : "/uk/wf-events/webinars"
                  }
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Webinars
                </a>
              </li>
              <li>
                <Link
                  to="/subscribe"
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Newsletter
                </Link>
              </li>
            </ul>
          </div>

          <div className="w-1/2 mb-6 sm:mb-0 lg:mr-12 sm:w-auto">
            <p className="text-sm text-blue-dark leading-tight my-3 font-secondary">
              Resources
            </p>
            <ul>
              <li>
                <a
                  href="https://help.tanda.co/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Help
                </a>
              </li>
              <li>
                <Link
                  to={
                    this.state.country === "us"
                      ? "/integrations"
                      : "/uk/integrations"
                  }
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Integrations
                </Link>
              </li>
              <li>
                <Link
                  to={
                    this.state.country === "us"
                      ? "/workforce-management"
                      : "/uk/workforce-management"
                  }
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Workforce Management
                </Link>
              </li>
              <li>
                <Link
                  to={
                    this.state.country === "us"
                      ? "/tools/timesheet-calculator"
                      : "/uk/tools/timesheet-calculator"
                  }
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Free Timesheet Calculator
                </Link>
              </li>
              <li>
                <Link
                  to={
                    this.state.country === "us"
                      ? "/tools/scheduling-template"
                      : "/uk/tools/scheduling-template"
                  }
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Free {this.state.country === "uk" ? "Rota" : "Scheduling"}{" "}
                  Template
                </Link>
              </li>
            </ul>
          </div>

          <div className="w-1/2 mb-6 sm:mb-0 sm:w-auto">
            <p className="text-sm text-blue-dark leading-tight my-3 font-secondary">
              Company
            </p>
            <ul>
              <li>
                <Link
                  to={this.state.country === "us" ? "/about" : "/uk/about"}
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to={
                    this.state.country === "us"
                      ? "/contact-us"
                      : "/uk/contact-us"
                  }
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to={this.state.country === "us" ? "/cookies" : "/uk/cookies"}
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Cookies
                </Link>
              </li>
              {this.state.country === "uk" ? (
                <li>
                  <Link
                    to="/uk/gdpr"
                    className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                  >
                    GDPR
                  </Link>
                </li>
              ) : (
                ""
              )}
              <li>
                <Link
                  to={
                    this.state.country === "us"
                      ? "/privacy-policy"
                      : "/eu/privacy-policy"
                  }
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to={this.state.country === "us" ? "/terms" : "/uk/terms"}
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link
                  to={this.state.country === "us" ? "/faqs" : "/uk/faqs"}
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  FAQs
                </Link>
              </li>
              <li>
                {
                  // eslint-disable-next-line
                }
                <a
                  href="javascript:Cookiebot.renew()"
                  className="text-gray-500 text-sm leading-loose hover:text-blue-light"
                >
                  Change Cookie Preferences
                </a>
              </li>
            </ul>
          </div>
        </section>
        <hr className="mx-auto mb-8 border-gray-200" />
        <p className="text-center text-gray-500 leading-normal">
          Copyright &copy; {new Date().getFullYear()} Workforce.com. All rights
          reserved.
        </p>
      </footer>
    );
  }
}

export default withRouter(Footer);
